module.exports = __webpack_public_path__ + "static/media/07.b22901b3.wav";